import axios from 'axios'

export const BaseURLS = {
  base: process.env.REACT_APP_API_BASE_URL,
  ws: `${process.env.REACT_APP_API_WS_URL}`,
  payment: process.env.REACT_APP_API_PAYMENT_URL,
  event: process.env.REACT_APP_API_EVENT_URL,
  rush: process.env.REACT_APP_API_RUSH_URL,
}

export const FIREBASE_URL =
  'https://asia-southeast1-ktx-finance-2.cloudfunctions.net/sailor_otherapi'

export const axiosInstance = axios.create({
  baseURL: BaseURLS.base,
})

export const paymentAxiosInstance = axios.create({
  baseURL: BaseURLS.payment,
})
